import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup'; // @ts-expect-error importing from JS file

import { saveUserAttribute } from 'AdsUI/actions/UserAttributesActions'; // @ts-expect-error importing from JS file

import { SEEN_FACEBOOK_CAPI_EVENT_BANNER } from 'AdsUI/data/UserAttributesData';
import { getEventLimits, getHubSpotUserId // @ts-expect-error importing from JS file
} from 'AdsUI/selectors/AuthSelectors'; // @ts-expect-error importing from JS file

import { getEnabledEventsCountForLimit } from 'AdsUI/selectors/EventsSelectors'; // @ts-expect-error importing from JS file

import { getRequestStatus } from 'AdsUI/selectors/RequestStatusSelectors'; // @ts-expect-error importing from JS file

import { getSeenFacebookCapiEventBanner } from 'AdsUI/selectors/UserAttributesSelectors';
import FacebookCapiEventCreationBanner from './FacebookCapiEventCreationBanner';
const RemainingEventsMessage = styled.div.withConfig({
  displayName: "FacebookCapiLifecycleStages__RemainingEventsMessage",
  componentId: "it2v7p-0"
})(["font-size:0.7rem;", ""], props => props.$isBelowLimit && css(["color:red;"]));

/**
 * The "Lifecycle stages" field for Facebook CAPI events.
 */
const FacebookCapiLifecycleStages = ({
  lifecycleStageOptions,
  numSelectedLifecycleStages,
  showErrors
}) => {
  const dispatch = useDispatch();
  const userId = useSelector(getHubSpotUserId);
  const hasSeenFacebookCapiEventBanner = useSelector(getSeenFacebookCapiEventBanner);
  const userAttributesRequestStatus = useSelector(getRequestStatus('userAttributes'));
  /** Evaluate if the banner should be displayed */

  const shouldDisplayBanner = useCallback(() => {
    return !hasSeenFacebookCapiEventBanner && userAttributesRequestStatus.fetched;
  }, [hasSeenFacebookCapiEventBanner, userAttributesRequestStatus.fetched]);
  const [displayBanner, setDisplayBanner] = useState(shouldDisplayBanner());
  const handleCloseBanner = useCallback(() => {
    setDisplayBanner(false);
    dispatch(saveUserAttribute(SEEN_FACEBOOK_CAPI_EVENT_BANNER, userId, true));
  }, [dispatch, userId]);
  const eventsLimit = useSelector(getEventLimits);
  const numEnabledEvents = useSelector(getEnabledEventsCountForLimit);
  const remainingEventCount = eventsLimit - numEnabledEvents - (numSelectedLifecycleStages || 0);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [displayBanner && /*#__PURE__*/_jsx(FacebookCapiEventCreationBanner, {
      close: handleCloseBanner
    }), /*#__PURE__*/_jsx(UIFormControl, {
      "data-test-id": "fb-capi-lifecycle-stages-field",
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "events.creation.CRM_EVENT.lifecycleStages.label"
      }),
      help: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "events.creation.CRM_EVENT.lifecycleStages.facebookCapiHelp"
      }),
      error: showErrors && !numSelectedLifecycleStages,
      validationMessage: showErrors && !numSelectedLifecycleStages && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "events.creation.CRM_EVENT.errors.lifecycleStageRequired"
      }),
      children: /*#__PURE__*/_jsx(UIToggleGroup, {
        "data-test-id": "fb-capi-lifecycle-stages-options",
        name: "fb-capi-lifecycle-stages-options",
        children: lifecycleStageOptions
      })
    }), /*#__PURE__*/_jsx(RemainingEventsMessage, {
      $isBelowLimit: remainingEventCount < 0,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "events.creation.CRM_EVENT.lifecycleStages.remainingEventCount",
        options: {
          count: remainingEventCount
        }
      })
    })]
  });
};

export default FacebookCapiLifecycleStages;